/* The shopper's machine's icon in the new header search and its machine sheet: the make's own mark on its colour (docs/make-marks.md), or its initial. */
(function () {
  'use strict';

  if (theme.searchMachineIcon) return;

  // The fitment app names machines "{year} {make} {model} {trim}"; the make is matched on the name after its year.
  const LEADING_YEAR = /^\d{4}\s+/;
  const MAKES = 'template[data-search-make-marks]';

  // A circle built before it's in any page, so it never changes size; decorative, as the name beside it says the make.
  function build(search, machineName) {
    const name = (machineName || '').trim().replace(LEADING_YEAR, '');
    const make = makeFor(search, name.toLowerCase());
    const icon = element('span', 'search-machine__icon');
    icon.setAttribute('aria-hidden', 'true');
    if (make) showMark(icon, make);
    else icon.append(initial(name));
    return icon;
  }

  // All the shopper's machines, as two of their makes overlapping in the one circle's place.
  function buildStack(search, machineNames) {
    const stack = element('span', 'search-machine__icon search-machine__icon--stack');
    stack.setAttribute('aria-hidden', 'true');
    stack.append(...machineNames.map((name) => build(search, name)));
    return stack;
  }

  // The app builds each garage row without telling its icon hook whose row it is, so each row is built, then given its icon.
  function markGarageRows(search, dropdown) {
    const createRow = dropdown._createGarageItemButton;
    dropdown._createGarageItemButton = function (vehicle) {
      const row = createRow.call(this, vehicle);
      row.prepend(build(search, vehicle && vehicle.displayName));
      return row;
    };
  }

  // The mark is drawn in the page or text colour, as snippets/predictive-search.liquid decided for this make's colour.
  function showMark(icon, make) {
    const mark = element('span', 'search-machine__mark');
    mark.style.setProperty('--machineMark', `url(${JSON.stringify(make.mark)})`);
    icon.classList.add('search-machine__icon--make', `search-machine__icon--${make.markTone === 'light' ? 'light' : 'dark'}-mark`);
    icon.style.setProperty('--machineMakeColor', make.color);
    icon.append(mark);
  }

  // A make the Make table doesn't hold yet shows its first letter, never a generic glyph.
  function initial(name) {
    const letter = element('span', 'search-machine__initial');
    letter.textContent = name.charAt(0).toUpperCase();
    return letter;
  }

  // The longest make the name starts with, as a make can have a space ("CF Moto").
  function makeFor(search, name) {
    const template = search.querySelector(MAKES);
    const makes = template ? Array.from(template.content.querySelectorAll('[data-make]')) : [];
    const named = makes.filter((make) => name.startsWith(`${make.dataset.make} `));
    const longest = named.sort((a, b) => b.dataset.make.length - a.dataset.make.length)[0];
    return longest ? longest.dataset : null;
  }

  function element(tag, className) {
    const node = document.createElement(tag);
    node.className = className;
    return node;
  }

  theme.searchMachineIcon = { build, buildStack, markGarageRows };
})();
